import axios from "axios";
import { useQuery } from "react-query";
import { API_URL, imageUrl } from "../../../api/config";

const fetchStudie = async (slug: string) => {
    const { data } = await axios.get(`${API_URL}/api/v1/clubs/${slug}`);
    return data.body;
};

export const useStudie = ({slug}: {slug: string}) => {
    const { data, isLoading } = useQuery(["studie", slug], () => fetchStudie(slug), {
        onError: (error) => {
            console.log("error", error);
        }
    });

    let resultArray: string[][] = [];

    if(data?.description){
        let paragraphs = data.description.split(/<\/?p>/).filter(Boolean);
        resultArray = paragraphs.map((paragraph: any) => {
            let cleanedString = paragraph.replace(/&[^;\s]+;/g, '');
            let lines = cleanedString.split(/<br\s*\/?>/).map((s: any) => s.trim()).filter(Boolean);
            return lines;
        });
    }

    return {
        studie: {
            ...data,
            image: imageUrl(data?.image),
            otherImages: data?.otherImages?.map((img: any) => ({ image: imageUrl(img.image) })),
            description: resultArray.flat()
        },
        isLoading
    };
};
